import { formatNumber } from '@/client/utils/format';

export const shouldEnableToWinQuote = (enabled: boolean, currentOptionsIndex: number) =>
  enabled && currentOptionsIndex >= 0;

export const formatToWinMultiple = (value?: bigint | null, decimal = 0, precision = 2) => {
  if (value === undefined || value === null) return null;

  const numericValue = Number(value) / Math.pow(10, decimal);
  if (numericValue > 0 && numericValue < Math.pow(10, -precision)) {
    return `<${Math.pow(10, -precision).toFixed(precision)}x`;
  }

  return `${formatNumber(value, decimal, precision, ',', false)}x`;
};
